import { render, staticRenderFns } from "./banner-image.vue?vue&type=template&id=db7562f2&scoped=true&"
import script from "./banner-image.vue?vue&type=script&lang=js&"
export * from "./banner-image.vue?vue&type=script&lang=js&"
import style0 from "./banner-image.vue?vue&type=style&index=0&id=db7562f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7562f2",
  null
  
)

export default component.exports